import { Component, Input } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'pick-location',
    templateUrl: 'pick-location.component.html'
})
export class PickLocation {

    @Input("model") model: any = {
        Source: {
        },
        Destination: {
        }
    };


    onPickSourceLocation() {

    }

    onPickDestinationLocation() {

    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/pickLocation/pick-location.component.ts